// extracted by mini-css-extract-plugin
export default {"answersContainer":"styles_answersContainer__pNpNF","buttonContainer":"styles_buttonContainer__YppZu","button":"styles_button__B+hB5","titleClassName":"styles_titleClassName__xDQoh"};